import { createReactComponent } from '@tabler/icons-react';

export const IconCustomProgressPlay = createReactComponent(
  'outline',
  'customProgressPlay',
  'CustomProgressPlay',
  [
    [
      'path',
      {
        key: 'customProgressPlay-path-1',
        d: 'M10 20.777a8.942 8.942 0 0 1 -2.48 -.969',
      },
    ],
    [
      'path',
      {
        key: 'customProgressPlay-path-2',
        d: 'M14 3.223a9.003 9.003 0 0 1 0 17.554',
      },
    ],
    [
      'path',
      {
        key: 'customProgressPlay-path-3',
        d: 'M4.579 17.093a8.961 8.961 0 0 1 -1.227 -2.592',
      },
    ],
    [
      'path',
      {
        key: 'customProgressPlay-path-4',
        d: 'M3.124 10.5c.16 -.95 .468 -1.85 .9 -2.675l.169 -.305',
      },
    ],
    [
      'path',
      {
        key: 'customProgressPlay-path-5',
        d: 'M6.907 4.579a8.954 8.954 0 0 1 3.093 -1.356',
      },
    ],
    [
      'path',
      {
        key: 'customProgressPlay-path-6',
        d: 'M11 9l4 3l-4 3z',
        // fill: 'currentColor', // with filled play triangle?
      },
    ],
  ]
);
